<div class="toggle-container" [class.toggle-selected]="selected()" [class.toggle-disabled]="disabled()">
  <div class="toggle-label">
    <ng-content></ng-content>
  </div>
  <div class="toggle-switch" (click)="!disabled() && toggleClick.emit()">
    <div class="toggle-slider"></div>
  </div>
</div>
